export default __webpack_public_path__ + "static/media/linkedIn.bd9c79fb.svg";